import classnames from 'classnames/bind'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

export default function SummaryIcon({ id, small }) {
    switch (id) {
        case 'taxi':
            return (
                <img src={`/app/themes/taxi-stockholm/static/img/car-icons/${id}.png`} className={cx(styles.icon, {isSmall:small})} />
            );
        case 'business':
            return (
                <img src={`/app/themes/taxi-stockholm/static/img/car-icons/${id}.png`} className={cx(styles.icon, {isSmall:small})} />
            );
        case 'estate':
            return (
                <img src={`/app/themes/taxi-stockholm/static/img/car-icons/${id}.png`} className={cx(styles.icon, {isSmall:small})} />
            );
        case 'largeCar':
            return (
                <img src={`/app/themes/taxi-stockholm/static/img/car-icons/${id}.png`} className={cx(styles.icon, {isSmall:small})} />
            );
        case 'smallElectric':
            return (
                <img src={`/app/themes/taxi-stockholm/static/img/car-icons/${id}.png`} className={cx(styles.icon, {isSmall:small})} />
            );
        default: 
            return (
                <img src={`/app/themes/taxi-stockholm/static/img/option-icons/${id}.png`} className={cx(styles.icon, {isSmall:small})} />
            );
    }

    
}